import React, { useEffect, useState } from 'react'
import '../Scss/Home.scss'
import Slider from '../Components/Slider';
import CloseIcon from '@material-ui/icons/Close';

import Geocode from "react-geocode";
import FeatureProperty from '../Components/FeatureProperty';
import {properties} from '../data.js'
import AgentCard from '../Components/AgentCard';

const Home = () =>{
    const [CurrentCity, setCurrentCity] = useState('')

    useEffect(()=>{
        Geocode.setApiKey("AIzaSyDCEQmQGTaR1olWVIrrocz6QSbHtJ9NImo");
        navigator.geolocation.getCurrentPosition(function(position){
            Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(
                response=>{
                    setCurrentCity(response.results[4].address_components[0].long_name)
                }
            )
        })
    })

    return (
        <div>
            <section className="home-search">
                <h1>Let’s find a home that’s perfect for you.</h1>
                <p>Search confidently with your trusted source of homes for sale or rent</p>
                <div className="search-box">
                    <input className="search-text" type="text" name="search" placeholder="Search by City, Zip or State" autoComplete="off"/>
                    
                    <div className="search-btn" href="#">
                        Search
                    </div>
                    <span className="mr-2"><CloseIcon /></span>
                </div>
            </section>

            <section className="new-listings mt-5">
                <h4>New Listings near {CurrentCity}</h4>
                <FeatureProperty properties={properties}/>
            </section>

            <section className="areas mt-5">
                <div className="areas-container container">
                    <h2>HOT AREAS</h2>
                    <div className="area mt-3">
                        <div className="area-wrapper area-new-york" data-content="New York">
                            <div className=""></div>
                        </div>
                        <div className="area-wrapper area-los-angle area-right" data-content="Los Angle">
                            <div className="" ></div>
                        </div>
                        <div className="area-wrapper area-las-vegas" data-content="Las Vegas">
                            <div className=""></div>
                        </div>
                        <div className="area-wrapper area-seattle area-right" data-content="Seattle">
                            <div className="" ></div>
                        </div>
                    </div>
                    
                </div>
                

            </section>

            <section className="agents mt-5">
                <div className="agents-container container">
                    <h2>AGENTS</h2>
                    <Slider itemPerRow={3} itemNumber={5} arrow={false}>
                        <div className="p-2">
                            <AgentCard />
                        </div>
                        <div className="p-2">
                            <AgentCard />
                        </div>
                        <div className="p-2">
                            <AgentCard />
                        </div>
                        <div className="p-2">
                            <AgentCard />
                        </div>
                        <div className="p-2">
                            <AgentCard />
                        </div>
                    </Slider>
                    <div className="text-center"><button className="btn btn-danger">OUR TEAM</button></div>
                    
                </div>
                

            </section>

            <section className="testimonials mt-5">
                <div className="testimonials-container container">
                    <h2>TESTIMONIALS</h2>
                        <Slider itemPerRow={1} itemNumber={3} arrow={false}>
                            <div className="testimonial">
                                <div className="review">This theme is so beautiful, easy to customize (even with no coding knowledge). It has some many features (and some that I keep discovering!!). The customer service is amazing. Very intelligent, polite, quick to answer, and helpful. I recommend this theme to anyone looking for a real estate WP theme, or something similar that can be adapted.</div>
                                <div className="user-thumb" style={{backgroundImage:`url(/images/user.jpg)`}}></div>
                                <h5>Alana Dyan</h5>
                            </div>
                            <div className="testimonial">
                                <div className="review">This theme is so beautiful, easy to customize (even with no coding knowledge). It has some many features (and some that I keep discovering!!). The customer service is amazing. Very intelligent, polite, quick to answer, and helpful. I recommend this theme to anyone looking for a real estate WP theme, or something similar that can be adapted.</div>
                                <div className="user-thumb" style={{backgroundImage:`url(/images/user.jpg)`}}></div>
                                <h5>Alana Dyan</h5>
                            </div>
                            <div className="testimonial">
                                <div className="review">This theme is so beautiful, easy to customize (even with no coding knowledge). It has some many features (and some that I keep discovering!!). The customer service is amazing. Very intelligent, polite, quick to answer, and helpful. I recommend this theme to anyone looking for a real estate WP theme, or something similar that can be adapted.</div>
                                <div className="user-thumb" style={{backgroundImage:`url(/images/user.jpg)`}}></div>
                                <h5>Alana Dyan</h5>
                            </div>
                        </Slider>
                </div>
            </section>
        </div>
    )
}

export default Home